import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { GeneralSetting } from '@jms/model';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BehaviorSubject, tap } from 'rxjs';

@UntilDestroy()
@Injectable({ providedIn: 'root' })
export class GeneralSettingService implements OnDestroy {

    private _loading$ = new BehaviorSubject<boolean>(true);
    public readonly loading$ = this._loading$.asObservable();

    private _generalSettings = new BehaviorSubject<GeneralSetting>(null)
    public readonly generalSettings$ = this._generalSettings.asObservable();

    public readonly $generalSettings = toSignal(this.generalSettings$);

    public get generalSettings() {
        return this._generalSettings?.value;
    }

    constructor(
        private http: HttpClient
    ) {
        // this.refresh();
    }

    ngOnDestroy(): void { }

    public setGeneralSettings(settings: GeneralSetting): void {
        this._generalSettings.next(settings);
    }

    public refresh(): void {

        this._loading$.next(true);

        this.http
            .get<GeneralSetting>('/api/settings/tenant/generalsettings')
            .pipe(
                untilDestroyed(this),
                tap(x => {
                    this._generalSettings.next(x);
                    this._loading$.next(false);
                })
            )
            .subscribe();

    }


}
